import React, { useState, useEffect } from 'react';
import { DatePicker, Col, Layout, Button } from "antd";
import moment from "moment";
import { CALENDER_DATE_FORMAT } from '../../../settings';

import useWindowDimensions from '../../Common/Hooks/useWindowDimensions';

const OpenedDatepicker = ({
    data,
    selectedDate,
    setSelectedDate
}) => {
    const dimensions = useWindowDimensions();
    const isDisabledDate = current => {
        return moment(current).isBefore(moment(), 'day');

    }

    const getDateElement = current => {
        const style = {};
        style.color = '#b5b7ba';
        style.backgroundColor = 'white';

        if (!isDisabledDate(current)) {
            style.color = '#08B28D';
            style.fontWeight = 700;
        }

        if (moment(current).isSame(selectedDate)) {
            style.color = '#FF0000';
            style.fontWeight = 1700;
        }
        let bookingFlag = false;
        
        const currentDate = moment(current).format(CALENDER_DATE_FORMAT)
        
        Object.entries(data).forEach(
            ([key, value]) =>  {
                if (key === currentDate){
                    if(value.length) {
                        bookingFlag = true
                    }
                }
            }
          );

        return (
            <div  className="ant-calendar-date">
                {current.date()}
                {bookingFlag ? <span className="dot"></span> : null}
            </div>
        );
    };

    return (
        <>
            {dimensions?.width > 767 ? (
                <Col xl={8} lg={8} md={8} xs={24}>
                    <DatePicker
                        disabledDate={current => isDisabledDate(current)}
                        dateRender={current => getDateElement(current)}
                        showToday={false}
                        open
                        value={selectedDate}
                        onChange={(current) => setSelectedDate(current)}
                        allowClear={false}
                        dropdownClassName="host-picker"
                        bordered={false}
                    />
                </Col>) : (
                    <DatePicker
                        disabledDate={current => isDisabledDate(current)}
                        dateRender={current => getDateElement(current)}
                        showToday={false}
                        value={selectedDate}
                        onChange={(current) => setSelectedDate(current)}
                        allowClear={false}
                        dropdownClassName="host-picker"
                        bordered={false}
                />)}
        </>
    )
}

export default OpenedDatepicker;
